<div class="columns is-mobile">
    <div class="column">
        <p class="text is-level-1 is-marginless" [ngClass]="{ 'has-text-weight-bold': isBold }">{{ lineTitle }}</p>
    </div>
    <div class="column is-narrow">
        <span class="text is-level-1" [ngClass]="{ 'has-text-weight-bold': isBold }">
            {{ value }}
        </span>
    </div>
</div>
